export default __webpack_public_path__ + "static/media/closet2-1024w.2e2560f2.avif";